import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController, NavController, LoadingController } from '@ionic/angular';
import { SharingProvider } from '../../../providers/sharing/sharing';
import { PublicProfileModel, UserProvider } from '../../../providers/user/user';
import { BackgroundModel } from '../../../providers/value/value';
import { ResultProvider } from '../../../providers/result/result';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { Router } from '@angular/router';

/**
 * Generated class for the ResoultProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-result-profile',
  templateUrl: 'result-profile.html',
  styleUrls:['./result-profile.scss']
})
export class ResultProfilePage {
  profile: PublicProfileModel;
  profileTabs: string;
  backgrounds: BackgroundModel[];
  result = null;
  friendExist: boolean = false;

  constructor(
    public navCtrl: NavController,
    public router:Router,
    public translate: TranslateService,
    private shareService: SharingProvider,
    private sharer: SocialSharing,
    public actionSheetCtrl: ActionSheetController,
    private userService: UserProvider,
    private loadingCtrl: LoadingController,
    private resultService: ResultProvider
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};
    this.profile = state['profile'];
    console.log('prifile',this.profile)
    this.backgrounds = state['backgrounds'];
    this.result = state['result'];
    this.profileTabs = 'results';
    this.userService.friendExist(this.profile.id).then((result) => this.friendExist = result);
    console.log('this.result: ', this.result);
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter ResoultProfilePage');
  }

  async showActionSheet() {
    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('GLOBAL_OPTIONS'),
      buttons: [
        {
          text: this.translate.instant('PUBLICPROFILE_DASBINICH'),
          role: 'dasbinich',
          handler: () => {
            // this.userService.thatsMe(this.profile.id);
          }
        },
        {
          text: this.translate.instant('GLOBAL_CANCEL'),
          role: 'cancel'
        }
      ]
    });

    actionSheet.present();
  }

  addFriend() {
    this.userService.addFriend(this.profile.id).then(friendList => {
      // var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
      // loader.present();
      // this.userService.getMyFans().then(fanList => {
      // (this.app.getRootNav() as NavController).push(MysportContactsPage, { friendList: friendList }).then(() => loader.dismiss());
      // });
      this.friendExist = true;
    });
  }

  removeFriend() {
    this.userService.removeFriend(this.profile.id).then(() => {
      this.friendExist = false;
    });
  }


  getProfileBg() {
    let themeImage = 'wood.jpg';

    if (typeof this.profile.themeName !== 'undefined' && this.profile.themeName !== '') {
      themeImage = this.backgrounds.find(x => x.value === this.profile.themeName).img;
    }
    return themeImage;
  }

  getHeaderShade() {
    let themeShade = 'dark';

    if (typeof this.profile.themeName !== 'undefined' && this.profile.themeName !== '') {
      themeShade = this.backgrounds.find(x => x.value === this.profile.themeName).shade;
    }

    return themeShade;
  }

  share() {
    this.sharer.shareViaFacebook('', null, "https://spooorts.de/ui/showTrophyPublicMe.jsf?mo=pub&id=" + this.profile.id + '&current=' + new Date().getTime());

  }
  onChangeProfileTabs(event:any){
    const selectedValue = event.detail?.value;
    this.profileTabs = selectedValue;
  }
}
